import React, { useState } from 'react';
import { DateRange } from 'react-date-range';

interface SafeDateRangeProps {
  ranges: any[];
  onChange: (item: any) => void;
  calendarKey?: string;
  [key: string]: any;
}

const SafeDateRange: React.FC<SafeDateRangeProps> = ({ ranges, onChange, calendarKey, ...rest }) => {
  const [error, setError] = useState<string | null>(null);

  const handleChange = (item: any) => {
    try {
      // Ensure the item has the required properties
      if (item && item.selection) {
        onChange(item);
      }
    } catch (err) {
      console.error('Error in SafeDateRange handleChange:', err);
      setError('Date range selection error occurred');
    }
  };

  if (error) {
    return (
      <div className="alert alert-danger">
        <strong>Error:</strong> {error}
        <button 
          className="btn btn-sm btn-outline-danger ms-2"
          onClick={() => setError(null)}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="rdrDateRangeWrapper">
      <DateRange
        key={calendarKey}
        ranges={ranges}
        onChange={handleChange}
        {...rest}
      />
    </div>
  );
};

export default SafeDateRange; 
